function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 0a16 16 0 1016 16A16 16 0 0016 0zm4.73 13.67l-5.49 6.06a1 1 0 01-.72.33 1 1 0 01-.71-.3l-2.5-2.56a1 1 0 111.43-1.4l1.76 1.8 4.77-5.27a1 1 0 111.48 1.34z"
})));